import { create } from "zustand";
import { ReactNode } from "react";

interface DrawerState {
  isOpen: boolean;
  title?: string;
  description?: string;
  children?: ReactNode;
  width?: number | string;
  placement?: "left" | "right" | "top" | "bottom";
  closable?: boolean;
  maskClosable?: boolean;
  onClose?: () => void;
}

interface DrawerStore extends DrawerState {
  openDrawer: (config: Omit<DrawerState, "isOpen">) => void;
  closeDrawer: () => void;
  setTitle: (title: string) => void;
  setDescription: (description: string) => void;
  setChildren: (children: ReactNode) => void;
  setWidth: (width: number | string) => void;
}

export const useDrawerStore = create<DrawerStore>((set) => ({
  isOpen: false,
  title: undefined,
  description: undefined,
  children: undefined,
  width: 400,
  placement: "right",
  closable: true,
  maskClosable: true,
  onClose: undefined,

  openDrawer: (config) => {
    set({
      isOpen: true,
      ...config,
    });
  },

  closeDrawer: () => {
    set((state) => {
      // Call onClose callback if provided
      if (state.onClose) {
        state.onClose();
      }
      return {
        isOpen: false,
        title: undefined,
        children: undefined,
        onClose: undefined,
      };
    });
  },

  setTitle: (title) => {
    set({ title });
  },

  setDescription: (description) => {
    set({ description });
  },

  setChildren: (children) => {
    set({ children });
  },

  setWidth: (width) => {
    set({ width });
  },
}));
